<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div class="modal_size lg_size">
            <a href="javascript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
            <dl class="modal_content">
                <dt class="ellipsis">
                    <i>{{ $t('BUTTON.GLOBAL.LIST') }}</i>
                </dt>
                <dd>

                    <!-- Grid -->
                    <div class="grid_wrap only_grid"  v-if="!isLoading" v-resize="setGridResizeColumn">
                        <!-- Count
                        <div class="grid_total">Total Count <em>{{ totalCount | numberFormat }}</em></div>
                        <div v-if="params.creationYn === 'Y'" class="btn_wrap">
                            <a href="javascript:" class="btn_white" :title="$t('BUTTON.GLOBAL.EXTEND.PERIOD')" @click="btnRecover">{{ $t('BUTTON.GLOBAL.EXTEND.PERIOD') }}</a>
                        </div>
                        -->
                        <content-grid
                            :gridId="gridId"
                            :ref="gridId"
                            :columns="columns"
                            :data="gridData"
                            :options="options"
                            :pageOptions="pageOptions"
                            :isTotalCount="false"
                            :click="contentClick"
                            @grid-total-count="setTotalCount"
                        />
                        <div class="paginate">
                            <sdl-pagination
                                align="center"
                                :current-page="currentPage"
                                :total-rows="totalCount"
                                :per-page="perPage"
                                @change="movePage"
                            />
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_modal_wrap topLine">
                        <div class="btn_right">
                            <a href="javascript:" class="btn_white" @click="$emit('close')">{{ $t('BUTTON.GLOBAL.CLOSE') }}</a>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import Vue                              	from 'vue';
import axios                            	from 'axios';
import qs                               	from 'query-string';
import { mapGetters, mapActions }       	from 'vuex';
import _                                	from 'lodash';
import resize                               from 'vue-resize-directive'
import SDLPagination						from '~~c/control/pagination/Pagination';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import DashboardContentsListGrid            from './DashboardConfigContentsListGrid';

export default {
	name: 'DashboardConfigContentsListPopup',
	props: {
        kpiType: { required: true },
		rtnFunc: { type: Function }
	},
	data() {
		return {
            isLoading: true,
            pageTitle: '',

            knowledgeList: [],

            gridId: 'myContentsListGrid',
            columns: [],
            options: {},
            pageOptions: {},
            gridData: [],

            totalCount: 0,
            pageNo: 1,
            currentPage: 1,
            perPage: localStorage.getItem('listRows') ? Number(localStorage.getItem('listRows')) : 10

		}
	},
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
            loginRhq: 'getLoginRhq',
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            params: 'getParams',
            locale: 'getLocale',
            menus: 'getMenus',
        }),
        getLoginNo()            { return this.loginNo || ''; },
        getUserRole()           { return this.userRoles || []; },
        getUserCorpCd()         { return this.userCorpCd || ''; },
        getLoginRHQCd()         { return this.loginRhq || ''; },
        getSelLoginCorp()       { return this.loginCorp || ''; },
        getPageNo()             { return this.pageNo; },

    },
    directives: { resize },
    components: {
        'sdl-pagination'    : SDLPagination,
        'content-grid'      : DashboardContentsListGrid,
    },
    methods: {
        // 처음 로딩 시
        initLoad() {
            SDLUtil.showLoadingBar(true);
            // 그리드 컬럼 세팅
            this.columns = this.getDynamicCols();

            this.isLoading = false;
            // 조회 완료 후
            SDLUtil.showLoadingBar(false);

            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(this.isLoading); }, 1000 );
            });
        },
        // 그리드 컬럼 percent resize 용
        getDynamicCols() {
            return [
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBJECT'), name: 'KNOWLEDGE_TITLE', align: 'left', width: this.getColumnSize(75), resizable: false, sortable: false },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.ADDED.BY'), name: 'REG_USER_NO', align: 'center', width: this.getColumnSize(13), resizable: false, sortable: false },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.DATE'), name: 'REG_DATE', align: 'center', width: this.getColumnSize(12), resizable: false, sortable: false },
                { header: 'CORP_NO', name: 'CORP_NO', hidden: true },
                { header: 'BOARD_ID', name: 'BOARD_ID', hidden: true },
                { header: 'IMPORTANCE_YN', name: 'IMPORTANCE_YN', hidden: true },
                { header: 'MUST_READ_YN', name: 'MUST_READ_YN', hidden: true },
                // <-- Return Value
                { header: 'KNOWLEDGE_ID', name: 'KNOWLEDGE_ID', hidden: true },
                { header: 'REG_DT', name: 'REG_DT', hidden: true },
                // Return Value -->
            ];
        },
        getColumnSize(size) {
            if(isNaN(Number(size))) { return 0; }
            let gridWrapSize = document.getElementsByClassName('grid_wrap').length ? document.getElementsByClassName('grid_wrap')[0].clientWidth - 16 : 1000;
            return Math.floor((gridWrapSize - 40) / (100 / size));
        },
        setGridResizeColumn(e) {
            EventBus.$emit('content-grid-set-column', this.getDynamicCols());
        },
        // 그리드 컬럼 percent resize 용

        // 페이지 이동
        movePage(pageNo) {
            this.currentPage = pageNo;
            this.handlePageSearch(pageNo);
        },
        // 총 합계 설정
        setTotalCount(totCnt) {
            this.totalCount = totCnt;
        },
        // 현재 페이지 설정
        setCurrentPage(page) {
            this.currentPage = page;
        },

        // Search Parameter setting
        setSearchParameter() {
            return { LIST_TYPE: this.kpiType === 'ICO' ? 'I' : 'M' };
        },
        // 정렬 조회 - 정렬로 조회하는 경우, 페이지를 1로 초기화 한다.
        handleSortSearch(sortObj) {
            if(!SDLUtil.isNull(sortObj.orderColName)) {
                this.ORDER_COLUMN = sortObj.orderColName;
                this.ORDER_ASC = sortObj.ascending ? "ASC" : "DESC";
            } else {
                this.ORDER_COLUMN = '';
                this.ORDER_ASC = '';
            }

            this.handlePageSearch(1);
        },
        // 페이지 조회
        handlePageSearch(pageNo){
            if(pageNo !== null && pageNo != "") {
                this.pageNo = pageNo;
                this.knowledgeList = [];
                this.handleSearch();

            } else {
                Vue.$log.warn('Page no is null');
            }
        },
        // 조회
        handleSearch() {
            // Call ExpiringKnowledgeListGrid.vue > loadData method
            EventBus.$emit('content-grid-search', this.setSearchParameter());
        },
        // 컨텐츠 클릭 이벤트
        contentClick(e, rowData, grid) {
            let colNm = e.columnName;
            if ((typeof e.rowKey) === "undefined") return;
            let row = rowData[e.rowKey];
            if(!SDLUtil.isNull(row['KNOWLEDGE_ID'])) {
                this.rtnFunc(row);
                this.$emit('close');
            }
        }
    },
    created(){
        // Vue.$log.info('▶ DashboardConfigContentsListPopup.vue created.', this.kpiType);
        EventBus.$on('page-search',             pageNo      => { this.handlePageSearch(pageNo); });
        EventBus.$on('sort-search',             sortForm    => { this.handleSortSearch(sortForm); });
    },
    mounted(){
        // DOM 생성 후 이벤트
        this.$nextTick(() => {
            this.initLoad().then(loading => {
                if(!loading) {
                    this.handleSearch();
                }
            });
        });

    },
    beforeDestroy(){
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('page-search');
        EventBus.$off('sort-search');
    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/dashboard/popup/DashboardConfigContentsListPopup.vue